import React, { useState, useRef } from "react"
import "./AddCategory.scss"
import { useNavigate } from "react-router-dom"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { InputText } from "primereact/inputtext"
import * as Yup from "yup"
import CategoryApi from "Api/CategoryApi"
import { Toast } from 'primereact/toast';
const AddCategory = () => {
  document.title = "Add Category"

  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const toast = useRef(null)
  const CategoryInitialData = {
    categoryName: "",
    description: "",
  }

  const [loading, setLoading] = useState(false)

  const [catgeoryData, setCategoryData] = useState(CategoryInitialData)

  const [errors, setErrors] = useState({})
  const handleCategoryDataChange = (name, value) => {
    setCategoryData({ ...catgeoryData, [name]: value })
    setErrors({ ...errors, [name]: "" })
  }

  const breadcrumbItems = [
    { label: "Pixwik", link: "/" },
    { label: "Category", link: "/categoryList" },
    { label: "Add Category" },
  ]
  const handleBreadcrumbClick = link => {
    if (link !== "#") {
      navigate(link)
    }
  }
  const ValidateCourse = Yup.object().shape({
    categoryName: Yup.string().required("Category  is required"),
    description: Yup.string().required("Description  is required"),
  })

  const addCategory = () => {
    setLoading(true)
    

  

    ValidateCourse.validate(catgeoryData, { abortEarly: false })
      .then(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
        CategoryApi.createCategory(catgeoryData, config)
        
          .then(res => {
               
            setLoading(false)
            setTimeout(() => {
              navigate("/categorylist")
            }, 1000)
            toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
            // toast.success(res.data.message)
              
            
          })
          .catch(error => {
            setLoading(false)
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 });
            
          })
      })
      .catch(err => {
        setLoading(false)
        const validationErrors = {}
        err ?.inner?.forEach(error  => {
          validationErrors[error.path] = error.message
        })
        setErrors(validationErrors)
      })
  }
  return (
    <>
    <Toast ref={toast} position="top-right" life="3000" />
    <div className="add-category">
    {/* <ToastContainer/> */}
      <Row>
        <Col xs="12">
          <div className="category-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Add Category" handleClick={handleBreadcrumbClick}   />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="category-add-form ">
                <div className="category-add-inp">
                  <label htmlFor="categoryName" className="label">
                    Category Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="categoryName"
                      value={catgeoryData.categoryName}
                      onChange={e =>
                        handleCategoryDataChange("categoryName", e.target.value)
                      }
                      placeholder="Enter Catgeory Name"
                      className="inp-field-box"
                    />
                    {errors.categoryName && (
                      <small className="error">{errors.categoryName}</small>
                    )}
                  </div>
                </div>
                <div className="category-add-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={catgeoryData.description}
                      onChange={e =>
                        handleCategoryDataChange("description", e.target.value)
                      }
                      placeholder="Enter Description"
                      className="inp-field-box"
                    />
                    {errors.description && (
                      <small className="error">{errors.description}</small>
                    )}
                  </div>
                </div>
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  onClick={() => {
                    addCategory()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Add"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
    </>
    )
}

export default AddCategory
